import { Navigate } from 'react-router-dom';

const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem('access_token');
  const guestMode = localStorage.getItem('guestMode') === 'true';
  
  // Allow access if authenticated OR in guest mode
  return (token || guestMode) ? children : <Navigate to="/login" />;
};

export default PrivateRoute;
